export default {"src":"/kareline/_next/static/media/Check.c6104a8a.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};